import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DecourseAddComponent } from './decourse-add.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '../../../shared/translate/translate.module';

@NgModule({
  declarations: [DecourseAddComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule
  ],
  exports: [DecourseAddComponent]
})
export class DecourseAddModule { }
